import { useMemo } from 'react';
import { useEventInfo } from '@shared/utils/eventInfo';
import type { MediaPhoto } from '../routes/Layout/components/HeaderPhotoCustomization/components/PhotoSelector/PhotoSelector.types';
import { useGetEventMediaQuery } from '@apps/admin/components/PhotoUploader/PhotoUploader.graphql.generated';

/**
 * Queries event media and returns photos sorted by most recent first.
 * Also exposes a ref for the loading state, safe to read inside stable useEventCallback closures.
 */
export const useEventMediaPhotos = () => {
  const { eventHandle } = useEventInfo();

  const { data: eventMedia, loading: eventMediaLoading } = useGetEventMediaQuery({
    variables: { eventHandle: eventHandle || '' },
    skip: !eventHandle,
    batchMode: 'fast',
  });

  const sortedEventMediaPhotos = useMemo(() => {
    const mediaPhotos = (eventMedia?.eventByName?.media?.filter(m => m.__typename === 'MediaPhoto') || []) as MediaPhoto[];
    return [...mediaPhotos].sort((a, b) => b.createdAt.milliseconds - a.createdAt.milliseconds);
  }, [eventMedia?.eventByName?.media]);

  return { sortedEventMediaPhotos, eventMediaLoading };
};
